import React from 'react';
import footerimg from '../../../assets/images/footer.png'


const Footer = () => {
    return (
        <div className=''>
            <footer className="footer p-10   mx-auto" style={{
            background:`url(${footerimg})`,
            backgroundSize:'cover'
        }}>
                <div>
                    <span className="footer-title">Services</span>
                    <a className="link link-hover">Design</a>
                    <a className="link link-hover">Marketing</a>
                    <a className="link link-hover">Advertisement</a>
                </div>
                <div>
                    <span className="footer-title">Company</span>
                    <a className="link link-hover">About us</a>
                    <a className="link link-hover">Branding</a>
                    <a className="link link-hover">Contact</a>
                    <a className="link link-hover">Jobs</a>
                    <a className="link link-hover">Press kit</a>
                </div>
                <div>
                    <span className="footer-title">Address</span>
                    <a className="link link-hover">DentisCare, Dhaka-1211</a>
                    <a className="link link-hover">Bangladesh</a>
                    
                </div>
            </footer>
            <p className='text-center my-10 text-sm'>Copyright © 2023 - All right reserved by DentisCare</p>
        </div>
    );
};

export default Footer;